import React, { useEffect, useState } from 'react'
import { Button, Paper, Slide, Typography } from '@material-ui/core'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import { Navigation } from '@material-ui/icons'
import * as gdeTransactions from '../../services/firestore/gdeTransactions'
// import { constantVersion } from '../../common/constants'

const useStyles = makeStyles((theme) => ({
  refreshImt: {
    position: 'fixed',
    zIndex: '9999',
    bottom: '50px',
    left: '50px',
    padding: theme.spacing(2),
  },
  button: {
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.main,
  },
}))

/**
 * Refresh is a component that displays a pop-up to inform the user about updates.
 *
 * @component
 * @returns {React.ReactElement} - React component
 */

const Refresh = () => {
  const [show, setShow] = useState(false)
  // const [userVersion, setUserVersion] = useState('')
  const [showActionPopup, setActionPopup] = useState(false)
  const [showNotificationPopup, setNotificationPopup] = useState(false)
  const theme = useTheme()
  const [second, setSecond] = useState(30)
  const classes = useStyles()

  useEffect(async() => {
    const getConstantVersion = await gdeTransactions.getAppVersion()
    const constantVersion = getConstantVersion.versionNumber
    const storedData = localStorage.getItem('appVersion')
    // setUserVersion(storedData)
    const storedVersionNumber = storedData ? parseInt(storedData.replace('R', ''), 10) : null
    const constantVersionNumber = parseInt(constantVersion.replace('R', ''), 10)

    if (!storedData) {
      setShow(true)
      setNotificationPopup(true)
      localStorage.setItem('appVersion', constantVersion)
    } else if (Math.abs(constantVersionNumber - storedVersionNumber) > 1) {
      setSecond(10)
      setShow(true)
      setNotificationPopup(true)
      localStorage.setItem('appVersion', constantVersion)
    } else if (Math.abs(constantVersionNumber - storedVersionNumber) === 1) {
      setShow(true)
      setActionPopup(true)
      setNotificationPopup(false)
      localStorage.setItem('appVersion', constantVersion)
    } else {
      setShow(false)
      setNotificationPopup(false)
    }
  }, [])

  useEffect(() => {
    if (show) {
      const interval = setInterval(() => {
        setSecond((s) => (s > 0 ? s - 1 : 0))
      }, 1000)
      return () => clearInterval(interval)
    }
  }, [show])

  useEffect(() => {
    if (second === 0) {
      if (showActionPopup) {
        reload()
      } else {
        setShow(false)
      }
    }
  }, [second, showActionPopup])

  const reload = () => {
    window.location.reload()
  }

  return (
    <Slide
      direction="up"
      in={show}
      mountOnEnter
      unmountOnExit
      timeout={{
        appear: 500,
        enter: 300,
        exit: 500,
      }}
    >
      <Paper elevation={3} className={classes.refreshImt}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'row',
          }}
        >
          <Navigation htmlColor={theme.palette.primary.main} fontSize="large" />
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              flexGrow: 1,
              paddingLeft: 16,
              paddingRight: 16,
            }}
          >
            {showNotificationPopup
              ? (
                <>
                  <Typography variant="body1" component="span">
                    Hi, We have updated GDE for you to have an even better experience.
                  </Typography>
                </>
                )
              : (
                <>
                  <Typography variant="body1" component="span">
                    There is an update. Please refresh!
                  </Typography>
                  <Typography variant="caption" component="span" color="textSecondary">
                    Auto refreshing in {second} second(s).
                  </Typography>
                </>
                )}
          </div>
          {showActionPopup && (
            <div>
              <Button variant="outlined" color="primary" onClick={reload} className={classes.button}>
                Refresh Now
              </Button>
            </div>
          )}
        </div>
      </Paper>
    </Slide>
  )
}

export default Refresh
